module.exports = __webpack_public_path__ + "f1468cbdc88e6d491d527f49a205f25c.pdf";